import { useQuery } from 'react-query';

import { getCatalogFilterLocaleMetadata } from '../controllers/get-catalog-filter-locale-metadata';
import { getTranslatedLocaleConfig } from '../utils/catalog-locale';

export function useCatalogFilterLocaleMetadata(locale: string | undefined) {
  // Resolve BCP-47 variants (e.g. ar-SA → ar, ru-RU → ru) so the fetch fires
  // and the API receives the canonical preference code even when i18n.language
  // is still a full BCP-47 string before account preferences hydrate.
  const resolvedLocale = getTranslatedLocaleConfig(locale)?.localeCode;
  const shouldFetch = Boolean(resolvedLocale);

  const {
    data,
    isLoading: catalogFilterLocaleMetadataIsLoading,
    error: catalogFilterLocaleMetadataError,
  } = useQuery(['catalogFilterLocaleMetadata', resolvedLocale], () => getCatalogFilterLocaleMetadata(resolvedLocale!), {
    enabled: shouldFetch,
  });

  if (!shouldFetch) {
    return {
      catalogFilterLocaleMetadata: null,
      catalogFilterLocaleMetadataIsLoading: false,
      catalogFilterLocaleMetadataError: null,
    };
  }

  const catalogFilterLocaleMetadata = {
    skills:
      data?.skills?.map((skill) => ({
        label: skill.label,
        value: skill.name,
      })) || [],
  };

  return {
    catalogFilterLocaleMetadata,
    catalogFilterLocaleMetadataIsLoading,
    catalogFilterLocaleMetadataError,
  };
}
